import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import rootReducer from 'src/actions/configuration/rootReducer';

const createReduxStore = ({ backend, gateways, stores, preloadedState = {} }) => {
  const middleware = getDefaultMiddleware({
    thunk: {
      extraArgument: { backend, gateways, stores },
    },
  });

  const store = configureStore({
    reducer: rootReducer,
    middleware,
    preloadedState,
  });

  return store;
};

export default createReduxStore;
